import {
  ROLE_ALL,
  ROLE_GET,
  ROLE_DEL,
  ROLE_PUT,
  ROLE_POST,
  ROLE_LOADING,
  ROLE_ERROR,
} from '../types';
import api from '../../../utils/functions/api';

const BASE = `${process.env.REACT_APP_API_URL}/role`;

export const roleCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: ROLE_LOADING });
    const { data } = await api.post(BASE, payload);
    dispatch({ type: ROLE_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: ROLE_ERROR });
    throw new Error(error);
  }
};

export const roleAll = (params = {}) => async (dispatch) => {
  try {
    const { name = '', size = 999999, page = 1 } = params;
    const { data, status } = await api.get(`${BASE}?name=${name}&size=${size}&page=${page}`);
    if (status === 200) {
      dispatch({ type: ROLE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: ROLE_ERROR });
    throw new Error(error);
  }
};

export const roleGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(`${BASE}/${id}`);
    if (status === 200) {
      dispatch({ type: ROLE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: ROLE_ERROR });
    throw new Error(error);
  }
};

export const rolePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: ROLE_LOADING });
    const { data } = await api.put(`${BASE}/${id}`, payload);
    dispatch({ type: ROLE_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: ROLE_ERROR });
    throw new Error(error);
  }
};

export const roleDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: ROLE_LOADING });
    const { data } = await api.delete(`${BASE}/${id}`);
    dispatch({ type: ROLE_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: ROLE_ERROR });
    throw new Error(error);
  }
};
